import React from "react";
import "./EditThemeStyle.css";
import { TwitterPicker, ChromePicker } from "react-color";
import { FaPalette } from "react-icons/fa";
import { Popover, Radio } from "antd";
import ButtonEditRadius from "./ButtonEditRadius";
import UploadBackgroundImage from "./UploadBackgroundImage";

const EditThemeStyle = ({
  disabled,
  pageDetails,
  updateThemeColor,
  updateBTC,
  updateBBGC,
  updateBBR,
  updateThemeBackgroundSetting,
  refreshContextProvider,
}) => {
  const handleChangeThemeColor = async (color) => {
    console.log(color.hex);
    await updateThemeColor(color.hex);
  };
  const handleChangeButtonColor = async (color) => {
    await updateBBGC(color.hex);
  };
  const handleChangeFontColor = async (color) => {
    await updateBTC(color.hex);
  };

  return (
    <>
      <div
        className={
          disabled ? "popover-color disabled-section" : "popover-color"
        }
        disabled
      >
        <div className="color-picker-main">
          <div className="color-title">
            <div style={{ marginRight: "20px" }}>FOND</div>{" "}
            <Radio.Group
              onChange={(e) => {
                updateThemeBackgroundSetting(e.target.value);
              }}
              value={pageDetails.ThemeBackgroundSetting}
            >
              <Radio value="color">Couleur</Radio>
              <Radio value="image">Image</Radio>
            </Radio.Group>{" "}
          </div>
          {pageDetails.ThemeBackgroundSetting === "color" ? (
            <>
              <div className="color-picker">
                <TwitterPicker
                  colors={[
                    "#8997FF",
                    "#FFADB2",
                    "#6FE3BD",
                    "#FED383",
                    "#83C3FE",
                    "#FEA883",
                  ]}
                  disableAlpha={disabled}
                  color={pageDetails.ThemeColor}
                  onChangeComplete={handleChangeThemeColor}
                  triangle="hide"
                />
              </div>
              <Popover
                content={
                  <ChromePicker
                    // disableAlpha={disabled}
                    color={pageDetails.ThemeColor}
                    onChangeComplete={handleChangeThemeColor}
                  />
                }
                trigger="click"
                placement="right"
              >
                <div className="palette">
                  Palette <FaPalette style={{ marginLeft: "7px" }} />
                </div>
              </Popover>
            </>
          ) : (
            <>
              {pageDetails.BackgroundImage ? (
                <img
                  className="showcase-bg-image"
                  src={pageDetails.BackgroundImage}
                  width="100px"
                  alt="bg image"
                />
              ) : (
                ""
              )}
              <UploadBackgroundImage
                pageDetails={pageDetails}
                refreshContextProvider={refreshContextProvider}
              />
            </>
          )}
        </div>
        <div className="color-picker-main">
          <div className="color-title">BOUTONS</div>
          <div className="color-picker">
            <TwitterPicker
              colors={[
                "#8997FF",
                "#FFADB2",
                "#6FE3BD",
                "#FED383",
                "#83C3FE",
                "#FEA883",
              ]}
              disabled={disabled}
              color={pageDetails.ButtonBackgroundColor}
              onChangeComplete={handleChangeButtonColor}
              triangle="hide"
            />
          </div>
          <Popover
            content={
              <ChromePicker
                // disableAlpha={disabled}
                color={pageDetails.ButtonBackgroundColor}
                onChangeComplete={handleChangeButtonColor}
              />
            }
            trigger="click"
            placement="right"
          >
            <div className="palette">
              Palette <FaPalette style={{ marginLeft: "7px" }} />
            </div>
          </Popover>
          <ButtonEditRadius pageDetails={pageDetails} updateBBR={updateBBR} />
        </div>
        <div className="color-picker-main">
          <div className="color-title">POLICE</div>
          <div className="color-picker">
            <TwitterPicker
              colors={[
                "#000000",
                "#FFFFFF",
                "#8997FF",
                "#FFADB2",
                "#6FE3BD",
                "#FED383",
              ]}
              disabled={disabled}
              color={pageDetails.ButtonTextColor}
              onChangeComplete={handleChangeFontColor}
              triangle="hide"
            />
          </div>
          <Popover
            content={
              <ChromePicker
                // disableAlpha={disabled}
                color={pageDetails.ButtonTextColor}
                onChangeComplete={handleChangeFontColor}
              />
            }
            trigger="click"
            placement="right"
          >
            <div className="palette">
              Palette <FaPalette style={{ marginLeft: "7px" }} />
            </div>
          </Popover>
        </div>
      </div>
    </>
  );
};

export default EditThemeStyle;
